import { Stack, Typography } from '@mui/material';
import { useFeatureEnabled } from 'api/appConfig';
import NotFound from 'illustrations/NotFound';
import CleanLink from 'components/shared/CleanLink';
import { ROUTES } from 'constants/routes';
import React from 'react';
import { S4Feature } from 'types/api';

const GuideNotFoundPage: React.FC = () => {
	const { enabled: ssoEnabled } = useFeatureEnabled(S4Feature.Sso);

	return (
		<Stack
			p={4}
			alignItems="center"
			gap={3}
			justifyContent="center"
			height="100%"
		>
			<Typography variant="h2">{intl.tr('404.title')}</Typography>
			<NotFound />
			<Typography variant="h3" mb={5}>
				{intl.tr('404.cta')}{' '}
				<CleanLink to={ROUTES.home}>
					<Typography display="inline" color="primary" variant="inherit">
						{intl.tr('404.homepage')}
					</Typography>
				</CleanLink>
				{/* the select IdP page is unreachable while SSO is disabled */}
				{ssoEnabled && (
					<>
						{' '}
						{intl.tr('404.or')}{' '}
						<CleanLink to={ROUTES.selectIdP}>
							<Typography display="inline" color="primary" variant="inherit">
								{intl.tr('404.selectIdP')}
							</Typography>
						</CleanLink>
					</>
				)}
			</Typography>
		</Stack>
	);
};

export default GuideNotFoundPage;
